import { useCallback, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { adminApi, getApiErrorMessage } from '../services/adminApi'
import { Alert, Badge, Button, Card, ConfirmAction, EmptyState, PageHeader, Spinner } from '../components/ui'

export default function Admins() {
  const navigate = useNavigate()
  const location = useLocation()
  const [admins, setAdmins] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')
  const [message, setMessage] = useState(location.state?.message || '')

  const load = useCallback(async () => {
    setLoading(true)
    try {
      const { data } = await adminApi.listAdmins()
      setAdmins(data.data || [])
    } catch (err) {
      setError(getApiErrorMessage(err))
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    load()
  }, [load])

  const toggle = async (id) => {
    try {
      await adminApi.toggleAdmin(id)
      load()
    } catch (err) {
      setError(getApiErrorMessage(err))
    }
  }

  const remove = async (id, email) => {
    try {
      await adminApi.deleteAdmin(id)
      setMessage(`Administrador ${email} excluído.`)
      load()
    } catch (err) {
      setError(getApiErrorMessage(err))
    }
  }

  if (loading) return <Spinner />

  return (
    <div className="space-y-6">
      <PageHeader eyebrow="Segurança" title="Administradores globais" description="Acessos autorizados ao ambiente administrativo." icon="fa-user-shield" actions={<Button icon="fa-plus" onClick={() => navigate('/admins/new')}>Novo admin</Button>} />
      {error && <Alert type="error">{error}</Alert>}
      {message && <Alert type="success">{message}</Alert>}

      <Card bodyClassName="!p-0">
        <div className="mp-scrollbar overflow-x-auto">
        <table className="w-full min-w-[680px] text-left text-sm">
          <thead>
            <tr className="border-b bg-slate-50/80 text-xs uppercase tracking-wide text-slate-500">
              <th className="px-5 py-3.5">E-mail</th>
              <th className="px-5 py-3.5">Perfil</th>
              <th className="px-5 py-3.5">Status</th>
              <th className="px-5 py-3.5">Ações</th>
            </tr>
          </thead>
          <tbody>
            {admins.map((a) => (
              <tr key={a.id} className="border-b border-slate-100 transition hover:bg-blue-50/40">
                <td className="px-5 py-4 font-semibold text-brand-deep">{a.email}</td>
                <td className="px-5 py-4">{a.role}</td>
                <td className="px-5 py-4">
                  <Badge tone={a.is_active ? 'success' : 'danger'}>
                    {a.is_active ? 'Ativo' : 'Inativo'}
                  </Badge>
                </td>
                <td className="px-5 py-4">
                  <div className="flex flex-wrap gap-1">
                    <Button variant="outline" className="!px-2 !py-1 text-xs" onClick={() => toggle(a.id)}>
                      {a.is_active ? 'Desativar' : 'Ativar'}
                    </Button>
                    <ConfirmAction className="!px-2 !py-1 text-xs" onConfirm={() => remove(a.id, a.email)} />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {!admins.length && <EmptyState title="Nenhum administrador cadastrado" icon="fa-user-shield" />}
        </div>
      </Card>
    </div>
  )
}
